import { Channel, Topic } from "../constants/index.js";
import { useCallback, useEffect } from "react";
import { MessageBrokerUtils } from "../utils/index.js";
import { CasinoActionCreators } from "../redux/action-creators/index.js";
import { useDispatch } from "react-redux";
import { Brand } from "../configurations/index.js";
import { useSelector } from "react-redux";
import {
  NativeSelectors,
  UserContextSelectors
} from "../redux/selectors/index.js";

export const useGamblingSession = () => {
  const dispatch = useDispatch();
  const brandID = useSelector(UserContextSelectors.brandId);
  const isNativeCISEnabled = useSelector(
    NativeSelectors.isCasinoInSportEnabled
  );

  const handleGamblingSession = useCallback(
    gamblingSession => {
      if (brandID === Brand.Sport_ES && !!isNativeCISEnabled) {
        dispatch(CasinoActionCreators.setGamblingSession(gamblingSession));
      }
    },
    [dispatch, brandID, isNativeCISEnabled]
  );

  useEffect(() => {
    const gamblingSessionSubscription = MessageBrokerUtils.subscribe({
      channel: Channel.PLAYER,
      topic: Topic.gamblingSessionUpdate,
      callback: handleGamblingSession
    });

    return () => {
      gamblingSessionSubscription?.unsubscribe();
    };
  }, [handleGamblingSession]);
};
